// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/index';
import '/vendor/js/flipclock.js';
import { socialProof } from './custom/social-proof.js';

$(document).ready(function () {
  $('.clock').FlipClock(600, {
    countdown: true,
  });

  offer.getState(function (data) {
    let iso_code = offer.getCountryIsoCode();
    socialProof(iso_code);
    if (iso_code == 'BE') {
      iso('de la BE', '/static/common/shared/country-flags/flag-be.svg', '/static/common/shared/lbl-new-be.svg');
    } else if (iso_code == 'LU') {
      iso('du LU', '/static/common/shared/country-flags/flag-lu.svg', '/static/common/shared/lbl-new-lu.svg');
    } else if (iso_code == 'CH') {
      iso('de la CH', '/static/common/shared/country-flags/flag-ch.svg', '/static/common/shared/lbl-new-ch.svg');
    } else {
      iso('de la FR', '/static/common/shared/country-flags/flag-fr.svg', '/static/common/shared/lbl-new-fr.svg');
    }
    function iso(text1, flag, lbl) {
      $('.dynamicCount1').html(text1);
      $('.dynamicFlag').attr('src', flag);
      $('.list-done-img').attr('src', lbl);
    }
  });
});
